import { createPortal } from 'react-dom';

export function HoverPillTooltip({
  label,
  left,
  top,
}: {
  label: string;
  left: number;
  top: number;
}) {
  return createPortal(
    <span
      className="pointer-events-none fixed z-[9999] whitespace-nowrap border px-3 py-1 text-xs font-semibold leading-none shadow-md shadow-slate-900/10 ring-1 ring-black/5"
      style={{
        left,
        top,
        transform: 'translateY(-50%)',
        borderRadius: 999,
        backgroundColor: '#ffffff',
        borderColor: '#bfdbfe',
        color: '#0f172a',
      }}
    >
      {label}
      <span
        className="absolute right-full top-1/2 h-2 w-2 -translate-y-1/2 translate-x-1 rotate-45 border-b border-l"
        style={{
          backgroundColor: '#ffffff',
          borderColor: '#bfdbfe',
        }}
      />
    </span>,
    document.body
  );
}
